Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_SESSION_SUCCESS = '@@redux-react-session/GET_SESSION_SUCCESS';
exports.GET_SESSION_ERROR = '@@redux-react-session/GET_SESSION_ERROR';
exports.GET_USER_SESSION_SUCCESS = '@@redux-react-session/GET_USER_SESSION_SUCCESS';
exports.GET_USER_SESSION_ERROR = '@@redux-react-session/GET_USER_SESSION_ERROR';
exports.INVALID_SESSION = '@@redux-react-session/INVALID_SESSION';